
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'

@Options({
    data () {
      return {
        isStart: false,
        isShowShare: false,
      }
    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData'])
    },
    created() {
      const share = this.$route.query.share;
      if (share) {
        // this.isShowShare = true;
        window.location.replace('https://mp.weixin.qq.com/s/QChQuwrgxw5DfR57X5Biaw');
      }
    },
    mounted () {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        console.log(homeShareData);
        homeShareData.link = homeShareData.link || window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
        this.isStart = true;
    }
})
export default class Home extends Vue {}
